import React from 'react'
import { Button, ConfigProvider, Space } from 'antd';
import { createStyles } from 'antd-style';

const useStyle = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    height: 50px;
    border-radius: 100px;
    padding: 0px 20px;
    position: relative;
    overflow: hidden;
    border: 0px;
    box-shadow: none;

    &.${prefixCls}-btn-primary:not([disabled]):not(.${prefixCls}-btn-dangerous) {
      background: transparent;
      color: #000000;
      border: 0px;
      font-size: 13px;

      &:hover {
        font-weight: bold;
      }
    }
  `,
}));

const useStyleGradient = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    height: 50px;
    border-radius: 100px;
    padding: 0px 40px;
    position: relative;
    overflow: hidden;
    border: 0px;
    box-shadow: none;
    font-weight: bold;

    &.${prefixCls}-btn-primary:not([disabled]):not(.${prefixCls}-btn-dangerous) {
      background: transparent;
      color: ##fff;
      background: linear-gradient(135deg, #0d4ace, #1de6a6);
      border: 0px;
      font-size: 13px;

      > span {
        position: relative;
        z-index: 1;
      }

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        opacity: 0;
        transition: opacity 0.4s ease;
        z-index: 0;
      }

      &:hover::before {
        opacity: 1;
      }

      &:hover {
        border-color: transparent;
      }
    }
  `,
}));

export const ButtonGradient = ({label, onClick, classSpace='', className = '', initialGradient = false}: any) => {
  const classesGradient = useStyleGradient();
  const classesNormal = useStyle();

   const { styles } = initialGradient ? classesGradient : classesNormal

  return (
    <ConfigProvider
      button={{
        className: styles.linearGradientButton,
      }}
    >
      <Space className={classSpace}>
        <Button type="primary" size="large" className={`text-opensans ${className}`} onClick={onClick}>
          {label}
        </Button>
      </Space>
    </ConfigProvider>
  );
}
